// Local Development Settings
const devSettings = {
    /* 
        Your Local DSS Location
        IE: '/localhost/localdss', 
    */
    dss: 'localhost/nine2021', 
    /* 
        The DSSAPI you want to dev against
        IE: '/localhost/localdss/api', 
            '/locahost:52394/api', 
            'http://ditwinw520/qaseattle_dss/api' 
            etc... 
    */
    dssapi: 'http://itdwigxcms501/qaseattle_dss/api', 
}

export default devSettings